import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const footerMenus = [
  {
    title: 'Conference',
    links: [
      { label: 'Topics and Special Sessions', to: '/topics-and-special-sessions' },
      { label: 'Tentative Program', to: '/tentative-program' },
      { label: 'Community Meetings', to: '/community-meetings' },
      { label: 'Awards', to: '/awards' },
      { label: 'Committees', to: '/committees' },
      { label: 'Contacts', to: '/contacts' },
    ],
  },
  {
    title: 'Participant info',
    links: [
      { label: 'Location', to: '/location' },
      { label: 'Venue', to: '/venue' },
      { label: 'Accommodation', to: '/accommodation' },
      { label: 'Travel', to: '/travel' },
      { label: 'Visa', to: '/visa' },
      { label: 'Social Events', to: '/social-events' },
    ],
  },
  {
    title: 'EAC2027',
    links: [
      { label: 'Welcome', href: '/#welcome' },
      { label: 'Important Dates', href: '/#important-dates' },
      { label: 'Organizers', href: '/#organizers' },
      { label: 'Sponsors', to: '/sponsors' },
      { label: 'Contact us', href: 'mailto:info@eac2027.si' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4">
          <Col lg={6}>
            <Link to="/" className="site-footer-brand" aria-label="EAC2027 home">
              <Image src="/eac2027light.svg" alt="EAC2027" className="site-footer-logo"
              />
            </Link>

            <p className="site-footer-intro">
              European Aerosol Conference 2027<br /> Ljubljana, Slovenia
            </p>
          </Col>

          {footerMenus.map((menu) => (
            <Col sm={6} lg={2} key={menu.title}>
              <h2>{menu.title}</h2>

              <ul className="site-footer-menu">
                {menu.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link to={link.to}>{link.label}</Link>
                    ) : (
                      <a href={link.href}>{link.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>

        <div className="site-footer-bottom">
          <p>
            © {new Date().getFullYear()} EAC2027. All rights reserved.
          </p>

          <p>
            Ljubljana, Slovenia · 5–10 September 2027
          </p>
        </div>
      </Container>
    </footer>
  );
}